import { jsx as _jsx } from "react/jsx-runtime";
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import cn from 'classnames';
import { textCall } from '../../../../constants/texts';
import { useWidgetContext } from '../../../../hooks/use-widget-context';
import { VoipTextCall } from '../../shared/text-call';
import styles from './index.module.css';
export const CancelledCall = () => {
    const { platform, isWebview } = useWidgetContext();
    return (_jsx(SidePanel.Body, { greed: true, className: cn({
            [styles.sidePanelBody]: platform === 'desktop',
            [styles.sidePanelBodyWebview]: isWebview,
        }), dataTestId: 'cancelled-call', children: _jsx(VoipTextCall, { text: textCall.CANCELLED_CALL }) }));
};
